import { motion } from "framer-motion";
import { Globe2, Pin, Link2, CalendarClock, Repeat2, ShieldCheck } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { features } from "@/data/content";
import { SectionHeader } from "@/components/SectionHeader";

const iconMap = { Globe2, Pin, Link2, CalendarClock, Repeat2, ShieldCheck };

const hexToRgba = (hex, a) => {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
};

export const Features = () => {
  const { t, lang } = useLang();

  return (
    <section id="features" data-testid="features-section" className="py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeader
          title={t.features.title}
          subtitle={t.features.subtitle}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-12">
          {features.map((f, i) => {
            const Icon = iconMap[f.icon];
            return (
              <motion.div
                key={f.id}
                data-testid={`feature-card-${f.id}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: (i % 2) * 0.08 }}
                className="group relative bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-6 hover:shadow-lg dark:hover:shadow-black/40 hover:-translate-y-1 transition-all duration-300 overflow-hidden"
              >
                <div
                  className="absolute top-0 inset-x-0 h-1"
                  style={{ backgroundColor: f.color }}
                />
                <div className="flex items-start gap-4">
                  <span
                    className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl"
                    style={{ backgroundColor: hexToRgba(f.color, 0.12), color: f.color }}
                  >
                    <Icon className="h-6 w-6" />
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-bold text-slate-950 dark:text-white">
                      {f.title[lang]}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-600 dark:text-slate-400">
                      {f.desc[lang]}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
